<template>
  <div class="ptb-100">
    <div class="container">
      <div class="section-title">
        <span class="top-title">Our Celebrities</span>
        <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Exclusively shining with us — only on MyCelebrity.</h2>
      </div>

      <div class="row justify-content-center">
        <div class="col-xl-4 col-md-6" v-for="team in teams" :key="team.id">
          <div class="team-single-team transition-y">
            <div class="position-relative z-1">
              <img
                title="We connect brands with celebrities and influencers for powerful digital campaigns."
                class="team-img"
                :src="team.image"
                alt="team"
                @click="goToTestimonial(team.id)"
                style="cursor:pointer" />
            </div>
            <div class="team-content">
              <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">{{ team.name }}</h3>
              <span>{{ team.designation }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="border-style pb-75"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import sharanyaImg from "../../assets/images/sharanya.jpg";
import rashmiImg from "../../assets/images/rashmi.jpg";
import reeshmaImg from "../../assets/images/reeshma.jpg";
import paroImg from "../../assets/images/paro.jpg";
import havocImg from "../../assets/images/havoc.jpg";
import adithiImg from "../../assets/images/adithi.jpg";

export default defineComponent({
  name: "OurTeam",
  setup() {
    const router = useRouter();
    // Static team data from testimonial content
    const teams = [
       {
        id: 1,
        name: "Aditi Prabhudeva",
        designation: "Kannada Actress",
        image: adithiImg,
        socials: [],
      },
      {
        id: 2,
        name: "Sharanya Shetty",
        designation: "Kannada Actress",
        image: sharanyaImg,
        socials: [],
      },
      {
        id: 3,
        name: "Rashmi Prabhakar",
        designation: "Kannada Actress",
        image: rashmiImg,
        socials: [],
      },
      {
        id: 4,
        name: "Reeshma Nanaiah",
        designation: "Kannada Actress",
        image: reeshmaImg,
        socials: [],
      },
      {
        id: 5,
        name: "Parvati Nair",
        designation: "Celebrity",
        image: paroImg,
        socials: [],
      },
      {
        id: 6,
        name: "Sudhan D",
        designation: "Creator",
        image: havocImg,
        socials: [],
      },
     
    ];
    const goToTestimonial = (id: number) => {
      // Map id to the correct testimonial page route
      const testimonialRoutes: Record<string, string> = {
        '1': '/testimonial-6',
        '2': '/testimonial-1',
        '3': '/testimonial-2',
        '4': '/testimonial-3',
        '5': '/testimonial-4',
        '6': '/testimonial-5',
      };
      const route = testimonialRoutes[String(id)] || `/testimonial/${id}`;
      router.push(route);
    };
    return { teams, goToTestimonial };
  },
});
</script>

<style lang="scss" scoped>
// Add top padding to prevent overlap with navbar
.ptb-100 {
  padding-top: 200px;
}

.team-single-team {
  border-radius: 20px;
  margin-right: 60px;
  margin-bottom: 25px;
  .team-img {
    border-radius: 20px;
    box-shadow: 60px 50px 0px #f2f2f8;
  }
  .team-content {
    padding: 20px 30px;
    background-color: #f2f2f8;
    margin-left: 60px;
    position: relative;
    z-index: 1;
    margin-right: -60px;
    border-radius: 20px;
    h3 {
      font-size: 22px;
      margin-bottom: 5px;
    }
  }
  .social-link {
    position: absolute;
    top: 50%;
    right: -46px;
    transform: translateY(-50%);
    li {
      margin-bottom: 15px;
      transition: var(--transition);

      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        transform: translateY(-3px);
      }
    }
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .team-single-team {
    .team-content {
      h3 {
        font-size: 20px;
        margin-bottom: 5px;
      }
      span {
        font-size: 15px;
      }
    }
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .team-single-team {
    .team-content {
      h3 {
        font-size: 20px;
        margin-bottom: 5px;
      }
      span {
        font-size: 15px;
      }
    }
  }
}
</style>